import * as __WEBPACK_EXTERNAL_MODULE_react__ from "react";
import * as __WEBPACK_EXTERNAL_MODULE_react_hook_form_05a66946__ from "react-hook-form";
import * as __WEBPACK_EXTERNAL_MODULE__context_js_80e2871f__ from "./context.js";
const useFormField = ()=>{
    const fieldContext = __WEBPACK_EXTERNAL_MODULE_react__.useContext(__WEBPACK_EXTERNAL_MODULE__context_js_80e2871f__.formFieldContext);
    const itemContext = __WEBPACK_EXTERNAL_MODULE_react__.useContext(__WEBPACK_EXTERNAL_MODULE__context_js_80e2871f__.formItemContext);
    const { getFieldState, formState } = (0, __WEBPACK_EXTERNAL_MODULE_react_hook_form_05a66946__.useFormContext)();
    const fieldState = getFieldState(fieldContext.name, formState);
    if (!fieldContext) throw new Error('useFormField should be used within <FormField>');
    const { id } = itemContext;
    return {
        id,
        name: fieldContext.name,
        formItemId: `${id}-form-item`,
        formDescriptionId: `${id}-form-item-description`,
        formMessageId: `${id}-form-item-message`,
        ...fieldState
    };
};
export { useFormField };

//# sourceMappingURL=use-form-field.js.map